import endpoint from "../../config/endpoints";

export const LeaveAnalysisJson = {
  showSaveNextBtn: true,
  formPath: "/leave-structure-form",
  apiBaseURL: endpoint.leaveStructure,
  changeExcel: endpoint.leaveStructure,
  openFormPathStatus: "/leave-structure-allotment",
  screenTitle: "Leave Analysis",
  showAddButton: true,
  showPdfDownload: true,
  pdfFileName: "Leave-Structure",
  showExcelDownload: false,
  excelFileName: "Leave-Structure",
  formPathView: "/leave-structure-view",
  tableColumnsToFilter: [
    {
      columnDisplayName: "Leave Structure",
      columnKeyName: "name",
      isChecked: true,
    },
  ],
  fieldMeta: [
    {
      label: "From Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "fromDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "toDate-le",
    },
    {
      label: "To Date",
      controlType: "datepicker",
      placeHolder: "",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 12,
      dataKey: "toDate",
      isMandatory: true,
      onSubmit: "compare",
      onSubmitParameter: "fromDate-ge",
    },
    {
      label: "Sales Team",
      controlType: "autocomplete",
      placeHolder: "Select Sales Team",
      md: 6,
      lg: 6,
      sm: 6,
      xs: 6,
      masterName: "salesPersonDetail",
      //   getListFrom: "stockStakeHolderType",
      dataKey: "salesTeamIds",
      isRootLevelKey: true,
      isMandatory: true,
    },
  ],
};
